export const messages = {
	PLEASE_WAIT: "お待ちください",
	CONFIRMED: "アカウントの登録に成功しました",
	ALREADY_CONFIRMED: "登録済みのアカウントです",
	MALFORMED_TOKEN: "無効な確認コードです。この画面が出続ける場合は、新しい登録メールを発行してください。",
	INVALID_EMAIL: "有効なメールアドレスを入力してください",
	MAIL_REQUEST_FAILED: "メール要求が失敗しました。時間をおいてから、もう一度お試しください。",
	PASSWORD_MISMATCH: "パスワードが一致していません。入力内容を確認するか、もう一度入力しなおしてください。",
	PASSWORD_RESET_FAILED: "パスワードのリセットに失敗しました。時間をおいてから、もう一度お試しください。",
	ACCOUNT_NOT_FOUND: '登録されていないメールアドレスです。入力したメールアドレスが間違っていないか確認してください。',
	INVALID_PASSWORD: 'パスワードは半角英数で8文字以上にしてください',
}

export default messages
